import { Link } from "react-router-dom";
import scrollToTop from "../components/scrolltotop";
import { reviews } from "../data/reviewdata";
import { useEffect, useState } from "react";

const HomePage = () => {
  const [randomReviews, setRandomReviews] = useState([]);

  useEffect(() => {
    const shuffled = [...reviews].sort(() => Math.random() - 0.5).slice(0, 4);
    setRandomReviews(shuffled);
  }, []);

  return (
    <>
      <div className="home-page-container">
        <div className="hero">
          <img
            src="https://d1sq738v7irhr2.cloudfront.net/home/home-desktop-hero.webp"
            alt="img"
            className="dhero"
          />
          <img
            src="https://d1sq738v7irhr2.cloudfront.net/home/home-ipad-hero.webp"
            alt="img"
            className="thero"
          />
          <img
            src="https://d1sq738v7irhr2.cloudfront.net/home/home-mobile-hero.webp"
            alt="img"
            className="mhero"
          />
          <img
            src="https://d1sq738v7irhr2.cloudfront.net/home/home-circle-tri.webp"
            alt="decorative"
            className="decor"
          />
          <h1>Learn anywhere, achieve everywhere!</h1>
          <div className="cta">
            <span>
              Interactive, flexible online lessons
              <br />
              built for today’s 11+ learners.
            </span>
            <Link to="/getstarted" className="btn lbtn" onClick={scrollToTop}>
              Start learning today!
            </Link>
          </div>
        </div>
        <div className="sect2">
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="text">
            <p>
              At Cito’s Learners we specialise in 11+ tutoring
              <span>, but what we offer goes far beyond exam preparation</span>.
              We are passionate about building strong foundations that support
              confident, capable learners for life.
            </p>
          </div>
          <Link to="/about" className="btn lbtn" onClick={scrollToTop}>
            {" "}
            Get to know us
          </Link>
          <div className="img-holder">
            <img
              src="https://d1sq738v7irhr2.cloudfront.net/home/citosicon.webp"
              alt="icon"
            />
          </div>
        </div>
        <div className="sect3">
          <h3>Our courses</h3>
          <div className="courses-container">
            <div className="course">
              <div className="course-content">
                <h5>Mathematics</h5>
                <p>
                  Help your child gain confidence and mastery in mathematical
                  concepts with our structured 11+ course.
                </p>{" "}
                <Link
                  className="btn"
                  to="/subjects/maths"
                  onClick={scrollToTop}
                >
                  Learn more
                </Link>
              </div>
            </div>
            <div className="course">
              <div className="course-content">
                <h5>English</h5>
                <p>
                  Build your child’s confidence in reading, comprehension, and
                  writing with clear, structured lessons.
                </p>{" "}
                <Link
                  className="btn"
                  to="/subjects/english"
                  onClick={scrollToTop}
                >
                  Learn more
                </Link>
              </div>
            </div>
            <div className="course">
              <div className="course-content">
                <h5>Verbal Reasoning</h5>
                <p>
                  Develop your child’s vocabulary with guided strategies that
                  make verbal reasoning simple  and rewarding.
                </p>{" "}
                <Link
                  className="btn"
                  to="/subjects/verbal-reasoning"
                  onClick={scrollToTop}
                >
                  Learn more
                </Link>
              </div>
            </div>
            <div className="course">
              <div className="course-content">
                <h5>Non-Verbal Reasoning</h5>
                <p>
                  Nurture your child’s visual reasoning and complex pattern
                  recognition skills.
                </p>{" "}
                <Link
                  className="btn"
                  to="/subjects/non-verbal-reasoning"
                  onClick={scrollToTop}
                >
                  Learn more
                </Link>
              </div>
            </div>
          </div>
          <Link className="btn lbtn" to="/subjects" onClick={scrollToTop}>
            More about our subjects
          </Link>
        </div>
        <div className="sect4" id="review-sect">
          <h3>Reviews</h3>
          <p>
            Don't just take our word for it, hear what other parents and
            guardians like you had to say!
          </p>
          <div className="reviews-container">
            {randomReviews.map((rev) => (
              <div key={rev.id} className="review">
                <span>“</span> <p>{rev.review}</p> <span>”</span>
              </div>
            ))}
          </div>
        </div>
        <div className="sect5">
          <h3>Book a free assessment</h3>
          <p>
            Start with a free assessment to discover your child’s current level
            and learning needs.
          </p>
          <Link to="/assessment" className="btn" onClick={scrollToTop}>
            Book now
          </Link>
          <img
            src="https://d1sq738v7irhr2.cloudfront.net/home/bubbles.webp"
            alt="bubbles"
            className="bubbles"
          />
        </div>
      </div>
    </>
  );
};

export default HomePage;
